import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  MagaziniSettoriTable,
  MagazziniSettori,
  ModelNumStr,
  ModelNumStrGroup,
  ModelNumStrNav,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniSettoriService extends CrudGenericsService<MagazziniSettori, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniSettori`);
    this.base = `${env.apiUrl}/api/MagazziniSettori/`;
  }
  // web
  Get4SelectGroup(): Observable<ModelNumStrGroup[]> {
    const u = `${this.base}Get4SelectGroup`;
    return this.http.get<ModelNumStrGroup[]>(u);
  }
  Get4Select_MagazzinoNavigation(): Observable<ModelNumStrNav[]> {
    const u = `${this.base}Get4Select_MagazzinoNavigation`;
    return this.http.get<ModelNumStrNav[]>(u);
  }
  Get4Select_ByMagazzino(id: number): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_ByMagazzino?id=${id}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  GetMagaziniSettoriTable(): Observable<MagaziniSettoriTable[]> {
    const u = `${this.base}GetMagaziniSettoriTable`;
    return this.http.get<MagaziniSettoriTable[]>(u);
  }
}
